import { COMPANY, ASSETS } from "@/lib/site";
import { AnimatedLogo } from "@/components/site/AnimatedLogo";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-ink">
      <div className="mx-auto max-w-[1600px] px-5 pb-10 pt-20 md:px-10">
        <AnimatedLogo src={ASSETS.logoEmblem} className="mb-10 h-24 md:h-28" />
        <h2 className="font-display text-[15vw] font-black uppercase leading-[0.82] tracking-tighter text-white md:text-[11vw]">
          Trey's <span className="text-stroke">Trucking</span>
        </h2>

        <div className="mt-16 grid grid-cols-1 gap-10 border-t border-white/10 pt-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="text-xs uppercase tracking-widest text-[#71717a]">Company</div>
            <p className="mt-3 text-sm leading-relaxed text-[#a1a1a8]">
              {COMPANY.legal}
              <br />
              Owner — {COMPANY.owner}
              <br />
              Est. {COMPANY.since}
            </p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-[#71717a]">Contact</div>
            <p className="mt-3 text-sm leading-relaxed text-[#a1a1a8]">
              <a href={COMPANY.phoneHref} className="hover:text-brand">{COMPANY.phone}</a>
              <br />
              <a href={`mailto:${COMPANY.email}`} className="break-all hover:text-brand">{COMPANY.email}</a>
            </p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-[#71717a]">Location</div>
            <p className="mt-3 text-sm leading-relaxed text-[#a1a1a8]">
              {COMPANY.address}
              <br />
              {COMPANY.city}
            </p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-[#71717a]">Services</div>
            <p className="mt-3 text-sm leading-relaxed text-[#a1a1a8]">
              Specialized Freight · OTR · Expedited · Dry Van · Flatbed
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 text-xs uppercase tracking-widest text-[#71717a] md:flex-row">
          <span>© {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.</span>
          <span>Serving the Lower 48 · Houston, TX</span>
        </div>
      </div>
    </footer>
  );
}
